import styled from 'styled-components'

export const ContainerButton = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: ${({ theme }) => theme.spacings[6]};
`

export const Title = styled.label`
  font-family: ${({ theme }) => theme.fonts.bloggerSans};
  font-style: normal;
  font-weight: 700;
  font-size: 34px;
  line-height: 37px;
  text-align: center;
  letter-spacing: 0.25px;
  padding-bottom: ${({ theme }) => theme.spacings[7]};
  margin-bottom: ${({ theme }) => theme.spacings[3]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.defaultGray};
  width: 100%;
`

export const ContainerBorder = styled.div`
  padding: ${({ theme }) => theme.spacings[10]};
  background: #f9f9f9;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
`
